import React, { Component } from 'react';
import {Link, Redirect} from "react-router-dom";
import {CheckVal} from "./../../utils/functions";

export default class AdminProductDashboard extends Component {

  componentDidMount = async() =>{
    let val = await CheckVal();
  }
  render() {
    return (
      <div className="full-height full-width">
        <div className="admin-hero-padding primary-background centered-text">
          <h2 className="white">{'Admin'}</h2>
        </div>
        <div className="row">
          <div className="small-12 medium-4 tiny-padding">
            <Link to="/admin/companies">
              <div className="shadow">
                <div className="small-padding primary-background centered-text">
                  <h3 className="white">{'Companies'}</h3>
                </div>
                <div className="small-padding centered-text">
                  <p className="subheading">{'Manage company information'}</p>
                </div>
              </div>
            </Link>
          </div>
          <div className="small-12 medium-4 tiny-padding">
            <Link to="/admin/products">
              <div className="shadow">
                <div className="small-padding primary-background centered-text">
                  <h3 className="white">{'Products'}</h3>
                </div>
                <div className="small-padding centered-text">
                  <p className="subheading">{'Manage and create products'}</p>
                </div>
              </div>
            </Link>
          </div>
          <div className="small-12 medium-4 tiny-padding">
            <Link to="/admin/packages">
              <div className="shadow">
                <div className="small-padding primary-background centered-text">
                  <h3 className="white">{'Packages'}</h3>
                </div>
                <div className="small-padding centered-text">
                  <p className="subheading">{'Manage and create product packages'}</p>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    )
  }
}
